























































import { Component, Watch } from "vue-property-decorator";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import { ProjectDevicesSettings, AllDevicesSettings, StandardIdentificationOptions } from "@/data/models/Settings";
import { AllDevicesSettingsModule } from "@/store/modules/AllDevicesSettingsModule";
import { defineOwnAllDevicesSettingsClientAccess } from "@/permissions/ClientPermissions";
import { createDefaultProjectDevicesSettings } from "@/data/models/Client";
import { updateAllDevicesSettings } from "@/data/repository/SettingsRepository";
import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import SettingsPageMixin from "@/components/settings/SettingsPageMixin";

@Component({
  components: {
    "confirmation-dialog": ConfirmationDialogComponent,
    picker: PickerDialogComponent,
  },
})
export default class ProjectDevicesSettingsComponent extends SettingsPageMixin {
  isInitializing = true;

  enforceMeterReading = false;
  standardIdentification = StandardIdentificationOptions.QR_CODE;

  initialProjectDevicesSettings: ProjectDevicesSettings = createDefaultProjectDevicesSettings();

  yesNoValues = [true, false];

  standardIdentificationOptions = Object.values(StandardIdentificationOptions);

  @Watch("allDevicesSettings")
  onAllDevicesSettingsChanged() {
    const projectDevicesSettings = this.allDevicesSettings.projectDevicesSettings;

    if (
      projectDevicesSettings && 
      !projectDevicesSettings.areDefaultProjectDevicesSettings
    ) {
      this.initializeParameters(projectDevicesSettings);  
    }
  }

  get hasChanged() {
    return (
      this.enforceMeterReading !== this.initialProjectDevicesSettings.enforceMeterReading ||
      this.standardIdentification !== this.initialProjectDevicesSettings.standardIdentification
    );
  }

  get allDevicesSettings() {
    return AllDevicesSettingsModule.allDevicesSettings;
  }

  get projectDevicesSettings() {
    return this.allDevicesSettings.projectDevicesSettings;
  }

  get canEdit() {
    return defineOwnAllDevicesSettingsClientAccess();
  }

  get readonly() {
    return !this.isEditMode || !this.canEdit;
  }

  get formatStandardIdentification() {
    return (standardIdentification: StandardIdentificationOptions) => {
      return this.getStandardIdentificationName(standardIdentification);
    };
  }

  getStandardIdentificationName(standardIdentification: StandardIdentificationOptions) {
    switch (standardIdentification) {
      case StandardIdentificationOptions.BARCODE:
        return this.$t(`common.barcode`).toString();   
      case StandardIdentificationOptions.NFC:
        return this.$t(`common.nfc`).toString();   
      default:
        return this.$t(`common.qrCode`).toString();   
    }
  }

  formatYesNo(value: boolean) {
    return this.$t(`common.${value ? "yes" : "no"}`).toString();
  }

  initializeParameters(
    projectDevicesSettings: ProjectDevicesSettings,
  ) {
    this.enforceMeterReading = projectDevicesSettings.enforceMeterReading;
    this.standardIdentification = projectDevicesSettings.standardIdentification;

    this.initialProjectDevicesSettings = projectDevicesSettings;

    this.isEditMode = false;
  }

  async created() {
    this.isInitializing = true;
    const projectDevicesSettings = this.allDevicesSettings.projectDevicesSettings;

    if (projectDevicesSettings && !projectDevicesSettings.areDefaultProjectDevicesSettings) {
      this.initializeParameters(projectDevicesSettings);
    }
    else {
      this.initializeParameters(createDefaultProjectDevicesSettings());
    }
    this.isInitializing = false;
  }

  async doSave() {
    const projectDevicesSettingsUpdate: ProjectDevicesSettings = {
      enforceMeterReading: this.enforceMeterReading,
      standardIdentification: this.standardIdentification,

      areDefaultProjectDevicesSettings: false,
    }

    const update: AllDevicesSettings = {
      ...this.allDevicesSettings,
      projectDevicesSettings: projectDevicesSettingsUpdate,
    }

    await updateAllDevicesSettings(update);

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.initialProjectDevicesSettings = update.projectDevicesSettings!!;
  }

  mounted() {
    this.setToolbarTitle(this.$t("settings.allDevices.projectDevicesSettings.title").toString());
  }
}
